import { IPaymentMethod } from '@checkout/state';
import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './PaymentLogosBar.scss';

interface IOwnProps {
  paymentMethods: IPaymentMethod[];
}

const PaymentLogosBar: React.SFC<IOwnProps> = ({ paymentMethods }) => {
  const paymentsWithLogo = paymentMethods.filter((item: IPaymentMethod) => item.paymentMethod.includes('_logo'));

  if (!paymentsWithLogo || paymentsWithLogo.length < 1) {
    return null;
  }

  const renderPaymentLogo = (item: IPaymentMethod) => {
    const classNames = cx({
      [Styles.logo]: true,
      [item.paymentMethod]: true,
    });

    return <div className={classNames} key={item.name}>{item.name}</div>;
  };

  return (
    <div className={Styles.wrapper}>
      {paymentsWithLogo.map((item: IPaymentMethod) => {
        return renderPaymentLogo(item);
      })}
    </div>
  );
};

export default PaymentLogosBar;
